import { api } from "./drogal-api";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { formatarDataHora, formatDate, formatTime } from "./ConvenioService";

export const exportarRelatorioVacinacao = async (dataInicio, dataFim) => {
  try {
    const response = await api.http.post(api.addresses.relatorioVacinacaoFiltro, {
      DataInicial: dataInicio,
      DataFinal: dataFim,
    });

    const dados = response.data; 

    if (!Array.isArray(dados) || dados.length === 0) {
      alert("Não existem dados para exportar.");
      return false;
    }

    // Filtrar por VC_DataHoraConfirmacao dentro do período selecionado
    const inicio = new Date(dataInicio + "T00:00:00");
    const fim = new Date(dataFim + "T23:59:59");

    const dadosFiltrados = dados.filter((item) => {
      if (!item.VC_DataHoraConfirmacao) return false;
      const dataConfirmacao = new Date(item.VC_DataHoraConfirmacao);
      return dataConfirmacao >= inicio && dataConfirmacao <= fim;
    });

    if (dadosFiltrados.length === 0) {
      alert("Não existem dados para o período selecionado.");
      return false;
    }

    const formatarData = (valor) => {
      if (!valor) return "";
      const data = new Date(valor);
      if (Number.isNaN(data.getTime())) return "";
      return data.toLocaleDateString("pt-BR");
    };


    const formatBooleanYesNo = (valor) => {
      if (!valor) return "Não";
      return "Sim";
    };

    const dadosFormatados = dadosFiltrados.map((item) => ({
      Paciente: item.VC_Paciente,
      CPF: item.VC_Cpf,
      DataNascimento: formatarData(item.VC_DataNascimento),
      Tipo: item.VC_Tipo,
      Titular: item.VC_Titular,
      Matricula: item.VC_Matricula,
      Confirmacao: formatBooleanYesNo(item.VC_Confirmacao),
      DataConfirmacao: formatDate(item.VC_DataHoraConfirmacao),
      HoraConfirmacao: formatTime(item.VC_DataHoraConfirmacao),
      Farmaceutico: item.VC_Farmaceutico,
      CRF: item.VC_CRF,
      Vacina: item.VC_Vacina,
      DoseAplicada: item.VC_DoseAplicada,
      NumeroLote: item.VC_NumeroLote,
      Fabricante: item.VC_Fabricante,
      Empresa: item.VC_Empresa,
      CNPJ: item.VC_DrogalCNPJ,
      UsuarioLogado: item.VC_UsuarioLogado,
      Cancelado: formatBooleanYesNo(item.VC_Cancelado),
      DataHoraCancelamento: formatarDataHora(item.VC_DataHoraCancelamento),
      Situacao: item.VC_Situacao,
      DataSituacao: formatarData(item.VC_DataSituacao),
      ProfissionalSaude: formatBooleanYesNo(item.VC_ProfissionalSaude),
      Gestante: formatBooleanYesNo(item.VC_Gestante),
      Data: formatarData(item.Data),
      Quantidade: item.Quantidade,
    }));

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Relatório");

    ws.columns = [
      { header: "Paciente", key: "Paciente", width: 45 },
      { header: "CPF", key: "CPF", width: 16 },
      { header: "Data Nascimento", key: "DataNascimento", width: 16 },
      { header: "Tipo", key: "Tipo", width: 14 },
      { header: "Titular", key: "Titular", width: 35 },
      { header: "Matrícula", key: "Matricula", width: 12 },

      { header: "Confirmação", key: "Confirmacao", width: 13 },
      { header: "Data Confirmação", key: "DataConfirmacao", width: 30 },
      { header: "Hora Confirmação", key: "HoraConfirmacao", width: 30 },
      { header: "Farmacêutico", key: "Farmaceutico", width: 28 },
      { header: "CRF", key: "CRF", width: 12 },

      { header: "Vacina", key: "Vacina", width: 30 },
      { header: "Dose Aplicada", key: "DoseAplicada", width: 14 },
      { header: "Nº Lote", key: "NumeroLote", width: 16 },
      { header: "Fabricante", key: "Fabricante", width: 20 },
      { header: "Empresa", key: "Empresa", width: 22 },
      { header: "CNPJ", key: "CNPJ", width: 20 },

      { header: "Usuário Logado", key: "UsuarioLogado", width: 20 },
      { header: "Cancelado", key: "Cancelado", width: 10 },
      { header: "Data/Hora Cancelamento", key: "DataHoraCancelamento", width: 28 },

      { header: "Situação", key: "Situacao", width: 10 },
      { header: "Data Situação", key: "DataSituacao", width: 16 },

      { header: "Profissional Saúde", key: "ProfissionalSaude", width: 18 },
      { header: "Gestante", key: "Gestante", width: 10 },

      { header: "Data (Relatório)", key: "Data", width: 16 },
      { header: "Quantidade", key: "Quantidade", width: 11 },
    ];

    ws.addRows(dadosFormatados);

    // Header em bold e centralizado
    ws.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    });

    ws.getRow(1).height = 22;
    ws.views = [{ state: "frozen", ySplit: 1 }];

    // Gera o arquivo
    const excelBuffer = await wb.xlsx.writeBuffer();

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const nome = `relatorio_vacinacao_${dataInicio}_${dataFim}.xlsx`;
    saveAs(blob, nome);

    return true;
  } catch (error) {
    console.error("Erro ao exportar relatório:", error);
    alert("Erro ao exportar relatório.");
    return false;
  }
};